import BasicSelect from "../generic/BasicSelect";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import React from "react";
import { URLSearchParamsInit } from "react-router-dom";

interface ForumOverviewProps {
    queryParams: Record<string, string>;
    setQueryParams: (queryObj: URLSearchParamsInit | undefined) => void;
    questionsCount: number;
}

const ForumOverview: React.FC<ForumOverviewProps> = ({ queryParams, setQueryParams, questionsCount }) => {
    return (
        <Paper
            sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: 170,
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h4" textAlign={"left"} padding={1}>
                        All Questions
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="h6" textAlign={"left"} padding={1} paddingTop={3}>
                        {questionsCount} Questions
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Stack direction={"row"} spacing={4} justifyContent={"center"}>
                        <BasicSelect
                            placeholder={"Sort by"}
                            choices={["Newest", "Votes", "Answers", "Views"]}
                            value={queryParams.sort || "Newest"}
                            onChange={(value: string) => setQueryParams({ ...queryParams, sort: value, page: "1" })}
                        />
                        <BasicSelect
                            placeholder={"Filter by"}
                            choices={["None", "Accepted", "Not Accepted", "No Answer"]}
                            value={queryParams.filter || "None"}
                            onChange={(value: string) => setQueryParams({ ...queryParams, filter: value, page: "1" })}
                        />
                    </Stack>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ForumOverview;
